import classNames from 'classnames';

import { ImageFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import Svg from '../../../components/Svg';

import textBaseStyle from '../../../components/Text/text-base.module.css';
import style from './card-image.module.css';

interface CardImageProps {
  alignment?: 'center' | 'left';
  caption?: null | string | undefined;
  image: ImageFragmentFragment | null | undefined;
}

const CardImage = ({
  alignment,
  caption,
  image,
}: CardImageProps) => {
  if (!image) {
    return null;
  }

  const isSvg = image.node.sourceUrl?.endsWith('.svg');

  return (
    <figure
      className={classNames(
        style.cardImageContainer,
        { [style.cardImageContainerCenter]: alignment === 'center' },
      )}
    >
      {isSvg
        ? <Svg image={image} />
        : (
          <AppImage
            fallbackHeight={360}
            fallbackWidth={360}
            image={image}
          />
        )}

      {caption && (
        <figcaption
          className={classNames(
            textBaseStyle.fontSize14,
            style.caption,
          )}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default CardImage;
